import React, { useReducer } from 'react'
export const InitContext = React.createContext({})

const initialState = {
  init: true,
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'SET_INIT':
      return {
        init: action.payload,
      }
    default:
      throw new Error()
  }
}

export const InitContextProvider = (Children) => {
  const Provider = (props) => {
    const [state, dispatch] = useReducer(reducer, initialState)
    return (
      <InitContext.Provider value={{ state, dispatch }}>
        <Children {...props} />
      </InitContext.Provider>
    )
  }
  return Provider
}
